import React, { useState } from "react";
import {
  Row,
  Col,
  Card,
  Space,
  Typography,
  Form,
  Button,
  Layout,
  Divider,
  message,
  Input,
  Progress,
  Tooltip,
} from "antd";
import {
  ArrowLeftOutlined,
  LockOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { validatePassword } from "../../helpers/validatePassword";
import { IMAGES } from "../../constants/images";
import { changeSenha } from "../../api/curriculoUsuario";

const { Title, Text } = Typography;

const styles = {
  row: {
    flexGrow: 1,
    padding: "1%",
  },
  textWhite: {
    color: "#ffffff",
  },
};

const title = (
  <Space direction="vertical">
    <Text style={styles?.textWhite}>• Minimo de 8 characters.</Text>
    <Text style={styles?.textWhite}>• Pelo menos 1 letra em maiúsculo.</Text>
    <Text style={styles?.textWhite}>• Pelo menos 1 letra em minúsculo.</Text>
    <Text style={styles?.textWhite}>• Pelo menos 1 numero.</Text>
    <Text style={styles?.textWhite}>• Pelo menos 1 character especial (@,.,$,#).</Text>
  </Space>
);

const validator = {
  senha: [{ required: true, message: "Informe a senha atual!" }],
  nova_senha: [
    { required: true, message: "Informe a nova senha!" },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || validatePassword(getFieldValue("nova_senha"))[0] >= 75) {
          return Promise.resolve();
        }
        return Promise.reject("Senha muito fraca!");
      },
    }),
  ],
  nova_senha_confirmation: [
    { required: true, message: "Informe novamente a senha!" },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || getFieldValue("nova_senha") === value) {
          return Promise.resolve();
        }
        return Promise.reject("As senhas não conferem!");
      },
    }),
  ],
};

const AlterarSenha = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [passwordLevel, setPasswordLevel] = useState({});

  const alterarSenha = async (formulario) => {
    setLoading(true);
    try {
      const retorno = await changeSenha(formulario);
      if (retorno?.statusCode === 200) {
        message.success("Senha alterada com sucesso!");
        navigate(-1);
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message?.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const onSubmit = (formulario) => {
    alterarSenha(formulario);
  };

  return (
    <Row justify="center" align="middle" className="full-width" style={styles?.row}>
      <Col xs={23} sm={18} md={14} lg={12} xl={8} xxl={6}>
        <Card>
          <Space direction="vertical" className="full-width" size={20}>
            <Layout.Content align="center">
              <img width={140} src={IMAGES?.recuperacaoSenha} className="resize-contain" />
            </Layout.Content>

            <Title className="title" align="center">
              Alterar Senha
            </Title>

            <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
              <Form.Item className="FormItem" label="Senha atual" name="senha" rules={validator?.senha} hasFeedback>
                <Input.Password
                  size="large"
                  className="input"
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  placeholder="Digite a senha atual"
                  iconRender={(visible) =>
                    visible ? <EyeOutlined /> : <EyeInvisibleOutlined style={{ color: "#000" }} />
                  }
                  disabled={loading}
                />
              </Form.Item>
              <Form.Item
                className="FormItem"
                label="Nova Senha"
                name="nova_senha"
                rules={validator?.nova_senha}
                hasFeedback>
                <Input.Password
                  size="large"
                  onChange={(val) => setPasswordLevel(validatePassword(val?.target?.value))}
                  className="input"
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  placeholder="Digite a nova senha"
                  iconRender={(visible) =>
                    visible ? <EyeOutlined /> : <EyeInvisibleOutlined style={{ color: "#000" }} />
                  }
                  disabled={loading}
                />
              </Form.Item>

              <Form.Item
                className="FormItem"
                label="Repetir Senha"
                name="nova_senha_confirmation"
                rules={validator?.nova_senha_confirmation}
                hasFeedback>
                <Input.Password
                  size="large"
                  className="input"
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  placeholder="Digite novamente a senha"
                  iconRender={(visible) =>
                    visible ? <EyeOutlined /> : <EyeInvisibleOutlined style={{ color: "#000" }} />
                  }
                  disabled={loading}
                />
              </Form.Item>

              <Form.Item className="FormItem">
                <Text type="secondary">
                  Força da senha{" "}
                  <Tooltip title={title}>
                    <InfoCircleOutlined />
                  </Tooltip>
                </Text>
                <Progress
                  percent={passwordLevel[0]}
                  size="small"
                  showInfo={false}
                  strokeColor={passwordLevel[1]}
                  status="exception"
                />
              </Form.Item>

              <Form.Item className="FormItem">
                <Button
                  size="large"
                  loading={loading}
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                  className="login-form-button">
                  Enviar
                </Button>
              </Form.Item>
            </Form>
          </Space>
          <Divider />
          <Form.Item className="FormItem">
            <Button icon={<ArrowLeftOutlined />} size="large" onClick={() => navigate("/")} loading={loading}>
              Voltar
            </Button>
          </Form.Item>
        </Card>
      </Col>
    </Row>
  );
};

export default AlterarSenha;
